import { makeStyles } from "@material-ui/core";
import { createMuiTheme } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  dropzone: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    borderWidth: "2px",
    borderRadius: "2px",
    borderColor: "#bfbdbd",
    borderStyle: "dashed",
    //backgroundColor: theme.palette.grey[50],
    color: "#bfbdbd",
    outline: "none",
    transition: "border .24s ease-in-out",
    cursor:"pointer"
  },
  container: {
      margin: theme.spacing(2, 4)
  },
  btn:{
    color:"#fff"
  },
  viewFileIcon:{
    margin:"-1vh",marginLeft:"1vh",marginRight:"1vw",cursor:"pointer"
  }
}));



export const getMuiTheme = (selectedTheme) => {
  return createMuiTheme({
    ...selectedTheme,
    overrides: {
      MuiTypography:{
        body1:{
          fontSize:"0.875rem"
        }
      },
      MuiFormLabel:{
        root:{
          fontSize:"0.875rem"
        }
      },
      PrivateSwitchBase:{
        root:{
          padding:5
        }
      }
      
    },
  })
}